import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getUserRoleCode, hasAnyRoleCode } from '../utils/userRoleUtils';

interface PrivateRouteProps {
  children: React.ReactNode;
  requiredRole?: string;
  requiredRoles?: string[];
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ 
  children, 
  requiredRole, 
  requiredRoles 
}) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  // Mostrar loading enquanto verifica autenticação
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        <span className="ml-2 text-gray-600">Verificando autenticação...</span>
      </div>
    );
  }

  // Redirecionar para login se não autenticado
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const userRoleCode = getUserRoleCode(user);
  const isVisitor = userRoleCode === 'user';
  const onCopilot = location.pathname === '/copilot' || location.pathname.startsWith('/copilot/');

  if (isVisitor && onCopilot) {
    return <Navigate to="/sign/inbox" replace />;
  }

  if (requiredRole || requiredRoles) {
    const rolesToCheck = requiredRoles || (requiredRole ? [requiredRole] : []);

    if (!hasAnyRoleCode(user, rolesToCheck)) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return <>{children}</>;
}; 